import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Header from 'src/components/Header/Header'
import { css } from 'styled-components'

interface TitleHeaderProps {
  className?: string
  title: React.ReactNode | string
}

const TitleHeader: React.FC<React.PropsWithChildren<TitleHeaderProps>> = (
  props,
): React.ReactElement => {
  return (
    <Header className={props.className}>
      <div
        css={css`
          display: flex;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              40,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                36,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `)}
          `}
        >
          {props.title}
        </span>
        {props.children}
      </div>
    </Header>
  )
}

export default TitleHeader
